import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-43691e98"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px","color":"black","font-weight":"700"} }, " 路线详情：", -1))
const _hoisted_2 = { class: "vote-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_icon_font = _resolveComponent("icon-font")!
  const _component_the_ebooks_card = _resolveComponent("the-ebooks-card")!
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_timeline = _resolveComponent("a-timeline")!
  const _component_LikeOutlined = _resolveComponent("LikeOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "center-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, {
        class: "center-div",
        style: { background: '#fff', padding: '75px 50px 20px 50px', margin: 0, minHeight: '720px' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_breadcrumb, {
                  separator: ">",
                  style: {"margin":"0px 0px 20px 10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_breadcrumb_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: '/' }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 首页 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_breadcrumb_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: { path: '/track' } }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 学习路径 ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_breadcrumb_item, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" 路线详情 ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_breadcrumb_item, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.track.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_typography_title, { level: 4 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.track.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_typography_paragraph, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_typography_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.track.description), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _hoisted_1,
                  _createElementVNode("span", null, _toDisplayString(_ctx.track.stepCount) + " 步骤 · " + _toDisplayString(_ctx.track.ebookCount) + " 门课", 1)
                ])
              ]),
              _: 1
            }),
            (_ctx.track.steps == undefined || _ctx.track.steps.length == 0)
              ? (_openBlock(), _createBlock(_component_a_empty, {
                  key: 0,
                  image: _ctx.simpleImage
                }, null, 8, ["image"]))
              : (_openBlock(), _createBlock(_component_a_timeline, {
                  key: 1,
                  style: {"margin-top":"10px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.track.steps, (stepObj) => {
                      return (_openBlock(), _createBlock(_component_a_timeline_item, {
                        key: stepObj.id
                      }, {
                        dot: _withCtx(() => [
                          _createVNode(_component_icon_font, {
                            type: "icon-buzhou",
                            style: {"font-size":"20px","font-weight":"700"}
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_title, { level: 5 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(stepObj.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_typography_paragraph, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_typography_text, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(stepObj.description), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_the_ebooks_card, {
                            data: stepObj.ebooks
                          }, null, 8, ["data"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_button, {
                type: "primary",
                shape: "round",
                size: 'large',
                onClick: _ctx.vote
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_LikeOutlined),
                  _createTextVNode("  点赞：" + _toDisplayString(_ctx.track.voteCount), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_back_top, { type: "default" }),
      _createVNode(_component_TheFooter)
    ]),
    _: 1
  }))
}